import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/delivery-invoices`;

  async getAllDeliveryInvoices(page?: number, limit?: number, order?: {}, filter: any = {}): Promise<{
    deliveryInvoices: any[],
    count: number
  }> {
    return this.getAll(page, limit, order, filter);
  }
  
  async getAll(page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<{
    deliveryInvoices: any[],
    count: number
  }>{
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => this.http.get(`${this.url}`, { params: params }).toPromise() );
  }
}
